import { render, staticRenderFns } from "./downloadIcon.vue?vue&type=template&id=21cea2eb&"
import script from "./downloadIcon.vue?vue&type=script&lang=js&"
export * from "./downloadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports